export const getAllNodesInSub = (sub, skipHidden=false) => {
    let state = sub.state;
    let nodes = [... sub.zMessages];
    if (sub.tracks) {
        nodes = [... nodes, ... sub.midiEffects.effects];
        for (let track of sub.tracks) {
            nodes = [... nodes, ... track.midiEffects.effects];
            nodes = [... nodes, ... track.effects];
        }
    }
    for (let obj of sub.zObjects) {
        if (skipHidden && state.spatial.hiddenObjects[obj.id]) {
            continue;
        }
        nodes.push(obj);
        let {effect} = obj;
        if (effect) {
            nodes.push(effect);
            if (effect.zObjects) {
                nodes = [
                    ... nodes,
                    ... getAllNodesInSub(effect)
                ];
            }
        } 
    }
    return nodes;
};

